// IntegratedLeaves.jsx — 통합 메뉴 연차 관리 (Phase 1-1d + 1-1e)
// LeaveManagement를 통합 모드 apiBase로 래핑 + 회사 필터 칩 상태 관리.
// 통합 모드 특이점: 구글시트 동기화 비활성 (PINE 원본에서만 동기화).
//   '유형 설정' 숨김(2026-10-06) — 템플릿은 회사마다 따로라 각 회사 연차 관리에서 고친다. 추가 창은 고른 직원 회사 것만.
import React, { useMemo, useState } from 'react';
import LeaveManagement from './LeaveManagement';

export default function IntegratedLeaves({ menuId, companyCodes, pageTitle }) {
  // 기본: 전부 on. companyCodes는 메뉴 생성 시 정렬된 배열 (정규화됨).
  const [selected, setSelected] = useState(() =>
    Array.isArray(companyCodes) ? [...companyCodes] : []
  );
  const settingsCode = useMemo(() => {
    const selectedCodes = Array.isArray(selected) && selected.length > 0 ? selected : companyCodes;
    return String(selectedCodes?.[0] || 'PINE').toUpperCase();
  }, [selected, companyCodes]);
  const settingsApiPathBuilder = (code = 'PINE') => (
    `/api/admin/integrated-menus/${menuId}/leaves/attendance-settings?codes=${encodeURIComponent(String(code || 'PINE').toUpperCase())}`
  );

  return (
    <LeaveManagement
      pageTitle={pageTitle || '연차 관리'}
      apiBase={`/api/admin/integrated-menus/${menuId}/leaves`}
      syncLeavesEndpoint=""
      hideSheetSync
      hideEventTypeSettings
      companyCodes={companyCodes}
      selectedCompanyCodes={selected}
      setSelectedCompanyCodes={setSelected}
      settingsApiPath={`/api/admin/integrated-menus/${menuId}/leaves/attendance-settings?codes=${encodeURIComponent(settingsCode)}`}
      settingsApiPathBuilder={settingsApiPathBuilder}
    />
  );
}
